import { Button, Col, Input, Select, Row } from "antd";
import { useNavigate } from "react-router-dom";
import useGet from "../../../global/hooks/useGet";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { HiArrowPath } from "react-icons/hi2";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { codetypeOptions } from "../../../utils/Common";

export const LicenseCodeFilter = ({
  filter,
  handleFilterChange,
  handleFilter,
  handleReset,
  setShowModal,
  selectedRowKeys,
  setFilter,
  modifiedItems,
  modifiedTypes,
}) => {
  const navigate = useNavigate();

  const onSearch = (value) => {
    console.log("search:", value);
  };
  const optionUrl = `${process.env.REACT_APP_API_URL}/api/licensecodes/getoptions/`;
  const {
    data: optionData,
    loading: optionDataLoading,
    error: optionDataError,
  } = useGet(optionUrl);
  const logData = JSON.parse(sessionStorage.getItem("userData"));
  const modifiedOems = getModifiedResponse(
    optionData,
    "oem_license_enabled_oems",
  );
  // useEffect(() => {
  //   if (postError) {
  //     openErrorNotification("Something went wrong");
  //   }
  // }, [postError]);

  return (
    <div className="">
      <div className="mt-2">
        <Row gutter={[16, 16]}>
          {/* <Col xs={24} sm={24} md={12} lg={6} xl={6}>
            <Input
              className="input_text_3 mr10 !h-full"
              name="No"
              placeholder="No"
              value={filter.No}
              onChange={handleFilterChange}
            />
          </Col> */}
          <Col xs={24} sm={24} md={12} lg={6} xl={6}>
            <Input
              className="input_text_3 mr10 h-full"
              name="Name"
              placeholder="Name"
              value={filter.Name}
              onChange={handleFilterChange}
            />
          </Col>

          {![4, 5, 6].includes(logData?.role_value) && (
            <Col xs={24} sm={24} md={12} lg={6} xl={6}>
              <Select
                showSearch
                placeholder="OEM"
                optionFilterProp="label"
                value={
                  filter.OemNo === "null"
                    ? "null"
                    : filter.OemNo || typeof filter.OemNo === "number"
                      ? Number(filter.OemNo)
                      : null
                }
                onChange={(value) => setFilter({ ...filter, OemNo: value })}
                // onSearch={onSearch}
                options={[{ label: "Generic", value: "null" }, ...modifiedOems]}
                style={{ width: "100%" }}
              />
            </Col>
          )}
          <Col xs={24} sm={24} md={12} lg={6} xl={6}>
            <Select
              showSearch
              placeholder="Code Type"
              optionFilterProp="label"
              value={
                filter.CodeType || filter.CodeType === 0
                  ? Number(filter.CodeType)
                  : undefined
              }
              onChange={(value) => setFilter({ ...filter, CodeType: value })}
              options={codetypeOptions}
              style={{ width: "100%" }}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={6} xl={6}>
            <Select
              showSearch
              placeholder="Item"
              optionFilterProp="label"
              value={
                filter.Item || typeof filter.Item === "number"
                  ? Number(filter.Item)
                  : null
              }
              onChange={(value) => setFilter({ ...filter, Item: value })}
              onSearch={onSearch}
              options={modifiedItems}
              style={{ width: "100%" }}
              allowClear
            />
          </Col>

          {/* <Col xs={24} sm={24} md={12} lg={6} xl={6}>
            <Select
              showSearch
              placeholder="Type"
              optionFilterProp="label"
              value={
                filter.Type || typeof filter.Type === "number"
                  ? filter.Type
                  : null
              }
              onChange={(value) => setFilter({ ...filter, Type: value })}
              onSearch={onSearch}
              options={modifiedTypes}
              style={{ width: "100%" }}
              allowClear
            />
          </Col> */}
        </Row>
      </div>
      <div className="w-full overflow-x-auto">
        <div className="flex justify-between mt-4">
          <div className="flex items-center">
            <Button
              type="primary"
              className="mr-2 w-[104px] h-[30px] font-medium flex"
              onClick={handleFilter}
            >
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              <span>Apply</span>
            </Button>
            <Button
              className="reset-button w-[104px] h-[30px] font-medium"
              onClick={handleReset}
            >
              <HiArrowPath className="!text-[14px] font-medium" />
              Reset
            </Button>
            {[1, 2, 3].includes(logData?.role_value) && (
              <Button
                type="primary"
                className="mr-2 -ml-2 w-[104px] h-[30px] font-medium"
                onClick={() => navigate("/licensecode/add")}
              >
                <PlusOutlined className="" />
                Add
              </Button>
            )}
            <Button
              type="primary"
              className="mr-2 w-[104px] h-[30px] font-medium"
              disabled={selectedRowKeys?.length === 0 ? true : false}
              onClick={() => {
                setShowModal(true);
              }}
            >
              <DeleteOutlined className="" />
              Delete
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
